/**
 * 404 PAGE TEMPLATE
 *
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {Link} from "react-router";

class PageFailLogin extends React.Component {

    logout = () => {
        let lneiSettings = JSON.parse(localStorage.getItem("lnei"));
        let auth = lneiSettings.authInfo;

        window.location = auth.wamLogout + "&redirecturl=" + encodeURIComponent(auth.customerUi) + "&lnsi=" + lneiSettings.authInfo.lnsi;
    };

    render() {
        let shouldShowLogoutButton = true;
        if (
            this.props.msgId === "General_CoreFunctionality_Error_error.UMLoginNotAllowed" ||
            this.props.msgId === "General_CoreFunctionality_Error_error.RESET_FROM_EMAIL" ||
            this.props.msgId === "General_CoreFunctionality_Error_error.EMAIL_SEND_FAILED" ||
            this.props.msgId === "General_CoreFunctionality_Error_error.WAM_USER_NOT_FOUND" ||
            this.props.msgId === "General_CoreFunctionality_Error_error.USER_PERM_ID_NOT_FOUND" ||
            this.props.msgId === "General_CoreFunctionality_Error_error.USER_ID_NOT_FOUND"
        ) {
            shouldShowLogoutButton = false;
        }

        return (

            <div className="error-404">

                <div className="error-404__title">
                    <FormattedMessage id="General_CoreFunctionality_Error_error.FailedLoginTitle" />
                </div>

                <div className="error-404__message">
                    <FormattedMessage id={this.props.msgId} />
                    {this.props.msgId === "General_CoreFunctionality_Error_error.WAMLoginNotAllowed"? <Link to="/login">Login</Link> : null}
                    {this.props.msgId === "General_CoreFunctionality_Error_error.UMLoginNotAllowed"? <Link to="/login/wam">Login</Link> : null}
                    {this.props.msgId === "General_CoreFunctionality_Error_error.RESET_FROM_EMAIL"? <Link to="/login/wam">Login</Link> : null}
                </div>

                {shouldShowLogoutButton ?
                    <div className="error-page__navigation">
                        <button className="button-green-lg" id="qa-error-page-button" onClick={this.logout}>
                            <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.user.signout" />
                        </button>
                    </div> : null}



            </div>

        );
    }
}

export default PageFailLogin;


// WEBPACK FOOTER //
// ./src/scripts/pages/ErrorPage/templates/ErrorPage.FailedLogin.jsx